import { apiClient } from './client';
import { API_ROUTES } from './routes';

export const paymentMethodService = {
  async list() {
    const response = await apiClient.get(API_ROUTES.SETTINGS.PAYMENT_METHODS);
    return response?.data || [];
  },

  async createSetup() {
    const response = await apiClient.post(API_ROUTES.SETTINGS.PAYMENT_METHODS_SETUP);
    return response?.data || null;
  },

  async remove(paymentMethodId) {
    const response = await apiClient.delete(API_ROUTES.SETTINGS.PAYMENT_METHOD(paymentMethodId));
    return response?.data || null;
  },

  async setDefault(paymentMethodId) {
    const response = await apiClient.put(API_ROUTES.SETTINGS.PAYMENT_METHOD_DEFAULT(paymentMethodId));
    return response?.data || null;
  },
};
